import { uniq } from 'lodash';
import React, { memo } from 'react';
import styled from 'styled-components';

import Tag from '../Tag';

interface ITagList {
  className?: string;
  placeholder?: string;
  tags?: string[];
  title?: string;
}

const TagList = ({
  tags,
  placeholder = 'Укажите теги',
  ...props
}: ITagList) => {
  if (!tags || !tags.length) {
    return <StyledPlaceholder>{placeholder}</StyledPlaceholder>;
  }

  const uniqTags = uniq(tags);

  return (
    <StyledTagList {...props}>
      {uniqTags.map(tag => (
        <Tag as="li" key={tag} tag={tag} />
      ))}
    </StyledTagList>
  );
};

const StyledTagList = styled.ul`
  display: flex;
  flex-wrap: wrap;
  font-size: 12px;

  > li {
    display: inline;
    font-size: inherit;
    padding-right: 5px;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }
`;

const StyledPlaceholder = styled.span`
  color: #919499;
`;

export default memo(TagList);
